import { Form, Formik } from 'formik';
import ParsedReceiptSummary, { type ParsedReceiptWrapper } from '../components/ParsedReceiptSummary';
import { useEffect, useState } from 'react';
import { useGetReceiptRuleByIdQuery, useTestReceiptRuleMutation } from '../receipt.api-slice';
import Breadcrumb from '../../../components/Breadcrumb';
import RuleSummary from '../components/RuleSummary';
import type { SampleReceipt } from '../../../common/types';
import Select from 'react-select';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetAllSampleReceiptsSelectQuery } from '../../sample-receipts/sample-receipt.api-slice';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ReceiptRuleTestPage: React.FC = () => {
  const { t } = useTranslation();
  const { ruleId } = useParams();
  const [selectedSampleReceipts, setSelectedSampleReceipts] = useState<string[]>([]);
  const [parseResultReady, setParseResultReady] = useState<boolean>(false);
  const { data: rule } = useGetReceiptRuleByIdQuery(ruleId ?? skipToken);

  const { data: sampleReceipts } = useGetAllSampleReceiptsSelectQuery();
  const [testRule, { data: parsedResult }] = useTestReceiptRuleMutation();

  const handleChangeItem = (newValue: any): void => {
    const currentSampleReceiptIds = newValue.map((sampleReceipt: SampleReceipt) => sampleReceipt.id);
    setSelectedSampleReceipts(currentSampleReceiptIds);
  };

  const handleSubmit = async (values: any, action: any): Promise<void> => {
    if (ruleId != null && selectedSampleReceipts.length !== 0) {
      await testRule({ ruleId, sampleReceiptIds: selectedSampleReceipts });
    }
  };

  useEffect(() => {
    if (parsedResult) {
      setParseResultReady(true);
    }
  }, [parsedResult]);

  return (
    <div>
      <div className="pb-4">
        <h1>{t('receiptRule.test.title')}</h1>
        <Breadcrumb items={[{ label: t('common.adminBreadcrumbLabel') }, { label: t('receiptRule.test.title') }]} />
      </div>

      <Formik onSubmit={handleSubmit} initialValues={{}}>
        {({ isSubmitting }) => (
          <Form className="w-full flex flex-col items-start px-2" autoComplete="off">
            <div className="w-full flex flex-col">
              <h1 className="text-2xl">Rule Summary</h1>
              {rule != null && <RuleSummary rule={rule} />}
            </div>

            <div className="w-full flex flex-col md:flex-row md:justify-between md:items-center space-y-2">
              <div className="w-full flex flex-col">
                <label className="w-full text-left text-gray-600">Sample Receipt</label>
                <div className="flex flex-col">
                  <Select
                    isMulti={true}
                    options={sampleReceipts}
                    onChange={handleChangeItem}
                    getOptionLabel={(sampleReceipt) => sampleReceipt.title}
                    getOptionValue={(sampleReceipt) => sampleReceipt.receipt}
                  />
                </div>
              </div>
            </div>
            <div className="w-full flex space-x-2 py-6 mt-4 border-t border-solid border-slate-200 rounded-b">
              <button type="button" className="w-1/2 text-black px-5 py-2 rounded-lg bg-gray-200">
                {t('receiptRule.test.cancelBtnLabel')}
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-1/2 text-white px-4 py-2 rounded-lg bg-[#1D8A43]"
              >
                {t('users.add.saveBtnLabel')}
              </button>
            </div>
          </Form>
        )}
      </Formik>
      <div className="flex flex-wrap justify-center mt-10">
        {parseResultReady &&
          Boolean(parsedResult) &&
          parsedResult.length > 0 &&
          parsedResult.map((result: ParsedReceiptWrapper, index: any) => {
            return <ParsedReceiptSummary key={index} result={result} />;
          })}
      </div>
    </div>
  );
};

export default ReceiptRuleTestPage;
